import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { getStoredAmplitudeUserId } from './amplitudeIdentity'

export function isAmplitudeEnabledForCurrentEnv(env = process.env) {
  return Boolean(
    env.REACT_APP_AMPLITUDE_API_KEY
      && (
        env.REACT_APP_APP_ENV === 'production'
        || env.REACT_APP_ENABLE_AMPLITUDE_NON_PROD === 'true'
      ),
  )
}

export function initAmplitudeForCurrentEnv(env = process.env) {
  const apiKey = env.REACT_APP_AMPLITUDE_API_KEY
  const isProduction = env.REACT_APP_APP_ENV === 'production'

  if (!apiKey || !isAmplitudeEnabledForCurrentEnv(env)) {
    console.error("Missing Amplitude API key, not tracking will be performed")
    return false
  }

  if (isProduction || env.REACT_APP_ENABLE_AMPLITUDE_NON_PROD === 'true') {
    console.log("NOTE: Amplitude tracking is enabled for production");

    const storedUserId = getStoredAmplitudeUserId()
    if (isProduction) {
      const sessionReplayTracking = sessionReplayPlugin({ sampleRate: 0.1 });
      amplitude.add(sessionReplayTracking);
    }
    amplitude.init(apiKey, {
      defaultTracking: true,
      userId: storedUserId || undefined,
    });
  }
  else {
      console.log("NOTE: This is not considered production, Amplitude tracking is disabled");
  }

  return true
}

